var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.hidden && !_vm.showHidden)?_c('input',{attrs:{"type":"hidden"},domProps:{"value":_vm.value}}):_c('div',{class:{ hidden: _vm.hidden, 'is-schema-field': true }},[_c(_vm.type,{tag:"component",attrs:{"schema":_vm.schema,"value":_vm.value,"name":_vm.name},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }